import Confirmation from "./components/confirmation/confirmation";
import DetailsForm from "./components/details-form/details-form";
import QueryForm from "./components/query-form/query-form";
import { AppState, useAppContext } from "src/services/context";
import { html } from "htm/preact";
import { render } from "preact";
import { effect, useSignal } from "@preact/signals";


/**
 * @typedef ReservationAppProps
 * @prop {import("src/types").Restaurant} initialLocation
 * @param {ReservationAppProps} props
 * @returns {import("preact").VNode}
 */
function ReservationApp(props) {
  const state = useAppContext();

  if (!state.selectedRestaurant.value) return null;

  return html`<div class="mx-reservation-form">
    <${QueryForm}
      isVisible=${!state.isSelectionValid.value &&
      !state.confirmedReservation.value}
    />
    <${DetailsForm}
      isVisible=${state.isSelectionValid.value &&
      !state.confirmedReservation.value}
    />
    <${Confirmation} isVisible=${state.confirmedReservation.value} />
  </div>`;
}

/**
 * @param {ReturnType<import("src/services/state").createAppState>} state
 * @param {import("preact").ContainerNode} target
 */
export function createReservationApp(state, target) {
  let initialLocation = { ...state.selectedRestaurant.value };

  render(
    html`<${AppState.Provider} value="${state}">
      <${ReservationApp} initialLocation=${initialLocation} />
    <//> `,
    target
  );
}
